// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"9249a20f","488":"5264dda9"}[chunkId] + ".chunk.js";
};